<template>
    <div class="cl-loop-pack-container" @mouseenter="hovered = true" @mouseleave="hovered = false">
        <div class="cl-loop-card-img-cont" @click="onSelectLoopPack(loop)">
            <img class="cl-loop-card-thumbnail" :src="loop.coverUrl" alt="thumbnail"/>
            <div v-if="hovered || songPressed" class="cl-loop-card-play-overlay">
                <img class="cl-loop-card-play-btn" src="../assets/image/play.png" alt="play"/>
            </div>
        </div>
        <div class="cl-loop-card-text-cont">
            <div>
                <div class="cl-loop-track-text">{{ loop.title }}</div>
            </div>
            <div class="cl-loop-card-footer">
                <div class="cl-play-demo-text" @click="onClickPlayDemo">PLAY DEMO</div>
                <a :href="loop.zipUrl" click.prevent="onClickDownload">
                    <img class="cl-loop-card-download" src="../assets/image/download-small.png" alt="download"/>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import downloadUrl from "../util";
    export default {
      name: 'LoopPackCard',
      props: {
        loop: {
          type: Object,
          required: true
        },
        onPlayDemo: {
          type: Function
        },
        onSelectLoopPack: {
          type: Function
        },
        songPressed: {
          type: Boolean
        }
      },
      data() {
        return {
          hovered: false,
          zip: ''
        }
      },
      methods: {
        onClickPlayDemo() {
            this.onPlayDemo(this.loop);
        },
        onClickDownload() {
          downloadUrl(this.loop.zipUrl);
        },
      }
    }
</script>
<style lang="scss">
    .cl-loop-pack-container {
        display: flex;
        flex-direction: column;
        width: 220px;
        height: 310px;
        background-color: #2b2b2b;
        border-radius: 6px;
        cursor: pointer;
        margin: 5px;
        align-items: center;
        padding: 10px 0 0 0;
        &:hover {
            opacity: 0.85;
        }
    }

    .cl-loop-card-text-cont {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: 100%;
        width: 100%;
        padding: 0 10px;
    }

    .cl-loop-track-text {
        font-size: 17px;
        font-family: Lato-Regular, sans-serif;
    }

    .cl-loop-card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .cl-loop-card-download {
        width: 20px;
        height: 20px;
    }

    .cl-play-demo-text {
        color: #e1a732;
        font-family: Lato-Regular, sans-serif;
        font-size: 15px;
        cursor: pointer;

        &:hover {
            filter: brightness(120%);
        }
    }

    .cl-loop-card-img-cont {
        position: relative;
        align-items: center;
    }

    .cl-loop-card-thumbnail {
        width: 200px;
        height: 200px;
        border-radius: 6px;
        object-fit: cover;
    }

    .cl-loop-card-play-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        transition: .3s ease;
        background: black;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 6px;
        width: 200px;
        height: 200px;
    }

    .cl-loop-card-play-btn {
        position: absolute;
        width: 45px;
        height: 52px;
        top: 35%;
        left: 42.5%;
        z-index: 1;
    }

    @media only screen and (max-width: 640px) {
        .cl-loop-pack-container {
            height: 220px;
            width: 142px;
            padding: 8px 0 0 0;
        }

        .cl-loop-card-text-cont {
            padding: 0 8px;
        }

        .cl-loop-track-text {
            font-size: 12px;
        }

        .cl-play-demo-text {
            font-size: 10px;
        }

        .cl-loop-card-download {
            width: 12px;
            height: 12px;
        }

        .cl-loop-card-thumbnail, .cl-loop-card-play-overlay {
            width: 130px;
            height: 130px;
        }

        .cl-loop-card-play-btn {
            width: 23px;
            height: 27px;
            top: 40%;
        }
    }
</style>